export default "__VITE_ASSET__D5BGh4Bu__"